import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    emailVerification: [],
    loading: false,
    error: null,
}

const emailVerificationSlice = createSlice({
    name: "emailVerification",
    initialState,
    reducers: {
        fetchEmailVerificationSuccess: (state, action) => {
            state.loading = false;
            state.emailVerification = action.payload;
        },
        fetchEmailVerificationFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const { fetchEmailVerificationSuccess, fetchEmailVerificationFailure } = emailVerificationSlice.actions;

export default emailVerificationSlice.reducer;
